import React, { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import PropTypes from "prop-types";
import GenericMasonry from "src/components/GenericMasonry";
import { searchImagesQuery } from "src/queries/searchImages.graphql";

const CompanyImagesTab = ({
  onSelect,
  leadingItems = [],
  onClickLeadingItems,
  avatarMode = false,
}) => {
  const [searchImagesLazy] = useLazyQuery(searchImagesQuery);

  const loadMoreImages = useCallback(
    (offset, limit, searchTerm) =>
      searchImagesLazy({
        variables: {
          input: { limit, offset, searchTerm, includeTotalCount: false },
        },
      }),
    [searchImagesLazy]
  );

  const normalizeItem = useCallback((item) => {
    return {
      id: item.id,
      src: item.url,
      alt: item.name,
      width: item.width,
      height: item.height,
      data: item,
    };
  }, []);

  const fetchItems = useCallback(
    async (page, limit) => {
      const { data, error } = await loadMoreImages(page * limit, limit);

      const images = data?.searchImages?.images || [];

      return {
        data: images.map(normalizeItem),
        error,
        hasMore: !!images?.length,
      };
    },
    [loadMoreImages, normalizeItem]
  );

  return (
    <GenericMasonry
      onSelectionChange={onSelect}
      fetchItems={fetchItems}
      leadingItems={leadingItems}
      onClickLeadingItems={onClickLeadingItems}
      avatarMode={avatarMode}
    />
  );
};

CompanyImagesTab.propTypes = {
  onSelect: PropTypes.func.isRequired,
  leadingItems: PropTypes.arrayOf(PropTypes.object),
  onClickLeadingItems: PropTypes.func,
  avatarMode: PropTypes.bool,
};

export default CompanyImagesTab;
